module.exports = __webpack_public_path__ + "3b129f58ca1df648f8de20e849aaee35.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-32.png
// module id = 3261
// module chunks = 0